import React from 'react';
import { Link } from 'react-router-dom';
import { Helmet } from 'react-helmet';
import { FaStar, FaShoppingCart, FaHeart, FaUser, FaHome, FaPhone, FaEnvelope } from 'react-icons/fa';

export default function Success() {
  return (
    <div>
      <Helmet>
        <title>Bestellung erfolgreich - Novurem Patisserie</title>
        <meta name="description" content="Ihre Bestellung bei Novurem war erfolgreich. Vielen Dank für Ihren Einkauf." />
      </Helmet>

      <section className="success-section">
        <div className="container">
          <div className="success-icon"><FaHeart /></div>
          <h1>Bestellung erfolgreich abgeschlossen</h1>
          <p>
            Vielen Dank für Ihre Bestellung bei Novurem Patisserie!<br />
            Wir haben Ihre Bestellung erhalten und werden uns umgehend um die Bearbeitung kümmern.<br />
            Sie erhalten in Kürze eine Bestätigung per E-Mail.
          </p>
          <p>Für Rückfragen erreichen Sie uns unter: +4977081869489</p>
          <div style={{ marginTop: '30px', display: 'flex', gap: '15px', justifyContent: 'center', flexWrap: 'wrap' }}>
            <Link to="/" className="btn btn-primary"><FaHome /> Zur Startseite</Link>
            <Link to="/about" className="btn btn-secondary"><FaHeart /> Über uns</Link>
          </div>
        </div>
      </section>
    </div>
  );
}